import React from 'react';
import {
  getHeroContent, HeroImage, StoreLogo, SearchBar, CartBtn, TabContent, StoreFooter, getTabLabel, InlineEditableText,FaHeart
} from './ThemeLayoutHelpers';

export default function ArcticLayout({ p }) {
  const T = p.storeTheme || {};
  const copy = getHeroContent(p, {
    eyebrow: "Winter Collection",
    title: "Crisp. Clean. Cool.",
    subtitle: "Experience freshness with our curated selection",
    primaryCta: "Shop Now",
    secondaryCta: "Explore",
  });

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-sky-50 via-white to-blue-50" style={{ fontFamily: T.fontFamily || "Inter, sans-serif" }}>
      {/* Navigation */}
      <nav className="sticky top-0 z-40 bg-white/80 backdrop-blur border-b border-sky-100">
        <div className="max-w-7xl mx-auto px-4 py-3 flex items-center gap-4">
          <StoreLogo storeInfo={p.storeInfo} border="border-2 border-sky-300" />
          <div className="flex-1">
            <p className="font-bold text-sky-900">{p.storeInfo?.businessName}</p>
            <p className="text-xs text-sky-600">❄️ Free shipping above ₹999</p>
          </div>
          <SearchBar searchQuery={p.searchQuery} setSearchQuery={p.setSearchQuery} theme={T} className="flex-1 max-w-md" />
          <div className="flex items-center gap-2">
            <button onClick={p.handleGoToWishlist} className="p-2 rounded-full hover:bg-sky-50 transition relative">
              <FaHeart className="text-sky-600" />
              {p.wishlistCount > 0 && <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-sky-500 text-white text-[10px] flex items-center justify-center">{p.wishlistCount}</span>}
            </button>
            <CartBtn p={p} />
            {p.userMenuElement}
          </div>
        </div>
      </nav>

      {/* Hero Video Section */}
      <section className="relative">
        <HeroImage p={p} themeId="arctic" className="h-[450px]">
          <div className="absolute inset-0 bg-gradient-to-r from-sky-900/70 via-sky-900/30 to-transparent" />
          <div className="absolute inset-0 flex items-center">
            <div className="max-w-7xl mx-auto w-full px-4">
              <div className="max-w-2xl">
                <span className="text-sm text-sky-200 font-mono tracking-wider"><InlineEditableText p={p} field="heroEyebrow" value={copy.eyebrow}>{copy.eyebrow}</InlineEditableText></span>
                <h1 className="text-5xl font-bold text-white mt-4"><InlineEditableText p={p} field="heroTitle" value={copy.title}>{copy.title}</InlineEditableText></h1>
                <p className="mt-4 text-sky-100 text-lg"><InlineEditableText p={p} field="heroSubtitle" value={copy.subtitle}>{copy.subtitle}</InlineEditableText></p>
                <div className="mt-8 flex gap-3">
                  <button onClick={() => p.setActiveTab("products")} className="px-8 py-3 rounded-full bg-white text-sky-700 font-bold hover:shadow-lg transition"><InlineEditableText p={p} field="primaryCtaText" value={copy.primaryCta}>{copy.primaryCta}</InlineEditableText></button>
                  <button onClick={() => p.setActiveTab("details")} className="px-8 py-3 rounded-full border border-white/40 text-white font-semibold hover:bg-white/10 transition"><InlineEditableText p={p} field="secondaryCtaText" value={copy.secondaryCta}>{copy.secondaryCta}</InlineEditableText></button>
                </div>
              </div>
            </div>
          </div>
        </HeroImage>
      </section>

      {/* Features Grid */}
      <div className="max-w-7xl mx-auto w-full px-4 -mt-8 relative z-10">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {[
            { icon: "🚀", label: "Fast Shipping", desc: "2-3 days delivery" },
            { icon: "✨", label: "Premium Quality", desc: "Best-in-class" },
            { icon: "🎯", label: "100% Authentic", desc: "Guaranteed" },
            { icon: "💎", label: "Best Price", desc: "Price match" },
          ].map(f => (
            <div key={f.label} className="bg-white rounded-xl p-4 text-center shadow-sm border border-sky-100">
              <div className="text-2xl mb-2">{f.icon}</div>
              <div className="font-semibold text-sky-800 text-sm">{f.label}</div>
              <div className="text-xs text-gray-500">{f.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto w-full px-4 mt-8">
        <div className="flex gap-2 border-b border-sky-200">
          {[["products", getTabLabel(p, "products")], ["services", getTabLabel(p, "services")], ["details", getTabLabel(p, "details")]].map(([k, l]) => (
            <button key={k} onClick={() => p.setActiveTab(k)} className={`px-6 py-3 text-sm font-semibold transition ${p.activeTab === k ? "text-sky-700 border-b-2 border-sky-500" : "text-gray-500 hover:text-sky-600"}`}>{l}</button>
          ))}
        </div>
      </div>

      <section className="flex-1 max-w-7xl mx-auto w-full px-4 py-8">
        <TabContent p={p} />
      </section>

      <StoreFooter p={p} />
    </div>
  );
}